import { Injectable } from '@angular/core';
import { MaintenanceType } from '@core/interfaces/maintenance-type';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceTypeService {

  constructor(private readonly apollo: Apollo) {}

  public async listMaintenanceTypes({ where, orderBy = 'name_asc', limit = 100, offset = 0 }): Promise<MaintenanceType[]> {
    const query = gql`
      query listMaintenanceTypes(
        $where: MaintenanceTypeWhereInput,
        $orderBy: MaintenanceTypeOrderByInput,
        $limit: Int,
        $offset: Int
      ) {
        maintenanceTypes( where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
          items {
            id
            name
            type
            archived
          }
        }
      }
    `;

    return this.apollo.query({
      query,
      variables: {
        where,
        orderBy,
        limit,
        offset
      }
    })
      .toPromise()
      .then((result) => {
        return result.data['maintenanceTypes']['items'];
      });
  }
}

